import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const ProtectSecondaryViewStore = GenericFieldFactory("PROTECT_SECONDARY_VIEW", null);